export default "__VITE_ASSET__f1f263d3__"